import { useSelector } from "react-redux";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";
import {
  INTERCEPTOR_TRIGGERS,
  INTERCEPTOR_TRIGGER_IDS,
} from "../../../../utils/interceptorTriggers";
import {
  buildInterceptorExtraData,
  filterInterceptorField,
} from "../interceptor/shared";

const FORM_CODE = "interceptorTimeOnSite3min";
const TRIGGER_INFO =
  INTERCEPTOR_TRIGGERS[INTERCEPTOR_TRIGGER_IDS.timeOnSite3min].info;

export default function InterceptorTimeOnSite3min() {
  const { cityName } = useSelector((state) => state.location);
  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.triggerThreeMinsOpen}
      goalSent={GOALS.triggerThreeMinsSent}
      filterField={filterInterceptorField}
      extraData={buildInterceptorExtraData({ info: TRIGGER_INFO, cityName })}
    />
  );
}
